export default "/assets/images/filter-critter-cuddler-box.a706042f2d3aea6b.png";